import styled from 'styled-components';
import {dFlexColumn, dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';
import {ellipsis} from '../../../globalVariables/GlobalVariables';

export const content = styled.div`
    ${dFlexColumn};
    height: 100%;
`;

export const poster = styled.div<{$bgColor?: string}>`
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: clip;
    background: ${p => p.$bgColor ?? 'var(--TA-color-bg-base-alt)'};

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const details = styled.div`
    ${dFlexColumnCenter};
    flex: none;
    gap: var(--space-md);
    padding: var(--space-xl) var(--space-lg);
    text-align: center;
`;

export const title = styled.h3`
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    word-break: break-word;
`;

export const venue = styled.p`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
    max-width: 100%;
    ${ellipsis}
`;
